import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface BookingHeaderProps {
  step: number;
  totalSteps: number;
  onBack: () => void;
}

const BookingHeader: React.FC<BookingHeaderProps> = ({ step, totalSteps, onBack }) => {
  const progressPercent = Math.round((step / totalSteps) * 100);

  return (
    <div className="bg-white shadow-sm border-b">
      <div className="container-max py-6">
        <div className="flex items-center justify-between">
          <button
            onClick={onBack}
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Retour à l'accueil</span>
          </button>
          
          <div className="text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-elegant text-white-gold">
              Iris Softech
            </h1>
            <p className="text-sm text-gray-600 mt-1">Prise de Rendez-vous</p>
          </div>
          
          <div className="text-right">
            <div className="text-sm font-medium text-gray-700">Étape {step}/{totalSteps}</div>
            <div className="text-xs text-gray-500">Planification: {progressPercent}%</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingHeader;
